<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" (click)="cancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pre class="text-wrap" [innerHTML]="message"></pre>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button type="button" class="btn btn-outline-primary" appDebounce (appDebounceClick)="confirm()">Confirmar</button>
  </div>
</div><!-- /.modal-content -->